import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { currencies } from "../../rbac-consts";
import { default as AdminCurrenciesContainer } from "./admin/TabsContainer";

const CurrenciesWrapper = () => {
  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={currencies.ADMIN}
      yes={() => (
        <AdminCurrenciesContainer />
      )}
    />
  );
};

export default CurrenciesWrapper;